import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// 1. Importe QueryClient e QueryClientProvider
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// 2. Crie uma instância do QueryClient
const queryClient = new QueryClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* 3. Envolva o <App /> com o <QueryClientProvider> */}
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>
);
